import { Stack, Text, Avatar, useTheme } from '@ltvco/refresh-lib/theme';
import { AccountResponse } from '@ltvco/refresh-lib/v1';

import { ProfileSection } from 'components/DeepSearch/components/ProfileSection';

type UserInfoSectionProps = {
  account: AccountResponse | undefined;
};

export const UserInfoSection = ({ account }: UserInfoSectionProps) => {
  const theme = useTheme();
  const userInfo = account?.account?.user_info;

  const firstName = userInfo?.first_name || '';
  const lastName = userInfo?.last_name || '';
  const email = userInfo?.email || '';
  const memberId = userInfo?.user_code || '';

  const getInitials = () => {
    if (firstName) {
      return firstName[0].toUpperCase();
    }
    if (lastName) {
      return `${lastName[0]}`.toUpperCase();
    }
    if (email) {
      return email[0].toUpperCase();
    }
    return 'U';
  };

  const accountDetailsStyle = {
    fontWeight: '400',
    fontStyle: 'regular',
    color: theme.palette.text.secondary,
  };

  return (
    <Stack spacing={1.5} sx={{ py: 1.5, px: 2 }}>
      <Stack direction="row" gap="12px" alignItems="flex-start">
        <Avatar
          sx={{
            backgroundColor: 'primary.main',
            fontSize: '12px',
            width: '24px',
            height: '24px',
          }}
        >
          {getInitials()}
        </Avatar>
        <ProfileSection account={account} />
      </Stack>
      <Text variant="caption" sx={accountDetailsStyle}>
        Member ID: {memberId}
      </Text>
      <Text variant="caption" sx={accountDetailsStyle}>
        {email}
      </Text>
    </Stack>
  );
};
